import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { SidebarRendererComponent } from '../../shared/ui-rms/components/sidebar-nav/sidebar-renderer/sidebar-renderer.component';
import { SidebarNavMenuService } from "../../shared/core-rms/sidebar-nav-menu.service";
import { MenuService } from "../../shared/core-rms/rms.menu.service";
import { PrimeNGConfig } from "primeng/api";
import { SidebarNavService } from "../../shared/core-rms/sidebar-nav.service";
import { Subscription } from "rxjs";

@Component({
    selector: 'sidebar-nav',
    templateUrl: './left-nav.component.html',
    styleUrls: ['./left-nav.component.css'],
    providers: [SidebarRendererComponent]
})
export class LeftNavComponent extends SidebarRendererComponent implements OnInit {
    sidebarSubscription: Subscription;
    subscription: Subscription;
    @Input() model: any[] = [];
    constructor(public nav: SidebarRendererComponent, public linksvc: SidebarNavMenuService,
        renderer: Renderer2,
        menuService: MenuService,
        primengConfig: PrimeNGConfig,
        private sidebarService: SidebarNavService) {
        super(renderer, menuService, primengConfig);
        this.sidebarSubscription = this.sidebarService.toggled$.subscribe(toggled => this.sidebarActive = !toggled);
        this.subscription = this.linksvc.links$.subscribe(m => this.model = m);
        nav.sidebarActive = false;
    }
    ngOnInit(): void {
        super.ngOnInit();

    }
    onMenuClick() {
        //this.nav.sidebarActive = !this.nav.sidebarActive;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscription?.unsubscribe();
        this.sidebarSubscription?.unsubscribe();
    }
}
